import Header from './common/header';
import Footer from './common/footer';
import "../globals.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import UserProvider from '../providers/UserProvider';
// import { Font } from '@next/font-google';


// import { Source_Sans_3 } from "next/font/google";
// import { Roboto } from "next/font/google";

// const source_sans_3 = Source_Sans_3({
//   subsets: ["latin"],
//   style: ["normal", "italic"],
// });


export default function Layout(props: any) {
  return (
    <UserProvider>
      <Header common={props.common} />
        {props.children}
      <Footer />
    </UserProvider>
  )
}